import { useAuthState } from 'react-admin';

/**
 * Czy jest sesja, z którą wolno pytać API.
 *
 * Elementy paska (licznik bezczynnych, dzwonek) i pulpit odpytywały API
 * od razu po zamontowaniu — także na ekranie logowania i w chwili między
 * zalogowaniem a zapisaniem tokena. Każde takie zapytanie kończyło się 401
 * (test e2e na dev, 28.09.2026). Pytamy dopiero, gdy react-admin potwierdził
 * sesję (`checkAuth`) i token faktycznie leży w magazynie przeglądarki.
 */
export function hasToken(): boolean {
  try {
    return Boolean(localStorage.getItem('token'));
  } catch {
    return false;
  }
}

export function useSessionReady(): boolean {
  // Bez wylogowania przy porażce — tym zajmuje się react-admin na poziomie
  // tras; tu chodzi tylko o to, żeby nie pytać bez sesji.
  const { authenticated } = useAuthState(undefined, false);
  return authenticated === true && hasToken();
}
